import { Component, OnInit } from '@angular/core';
import { FotoWareSettings } from 'app/Model/fotoWare/fotoWareSettings';
import { Message } from 'app/Model/System/Message';
import { FotoWareSettingsService } from 'app/Services/fotoWare/fotoWareSettings.service';
import { LoginService } from 'app/Services/login.service';
import { SystemService } from 'app/Services/system.service';

@Component({
    selector: 'np-fotoware-settings',
    templateUrl: './fotoWareSettings.component.html',
    standalone: false
})
export class FotoWareSettingsComponent implements OnInit {
  model: FotoWareSettings = new FotoWareSettings();
  isTested: boolean = false;
  connectionTestMessage: string = "";

  constructor(private fotoWareSettingsService: FotoWareSettingsService, public loginService: LoginService, private systemService: SystemService) {
    this.testConnection = this.testConnection.bind(this);
  }

  get readOnly(): boolean {
    return !this.loginService.isManager;
  }

  ngOnInit(): void {
    this.fotoWareSettingsService.get().subscribe((settings: FotoWareSettings) => this.model = settings);
  }

  update(): void {
    if (this.readOnly)
      return;

    this.fotoWareSettingsService.update(this.model).subscribe((result: FotoWareSettings) => {
      this.model.id = result.id;
      this.model.clientSecret = result.clientSecret;
      this.isTested = false;
    });
  }

  testConnection(): void {
    this.fotoWareSettingsService.testConnection().subscribe((result) => {
      this.isTested = result.success;
      this.connectionTestMessage = result.success ? "" : result.message;
      if (!result.success) {
        let msg = new Message();
        msg.type = "error";
        msg.message = result.message;
        this.systemService.notify(msg);
      }
    });
  }
}
